import React from 'react';
import { Autocomplete, TextField, Box, FormHelperText } from '@mui/material';

const default_algorithm_options = ['RS256', 'HS256', 'ES256', 'PS256'];

export default function AlgorithmsField({
  value,
  onChange,
  disabled = false,
  error = false,
  required = false,
}) {
  const algorithms = Array.isArray(value) ? value : [];

  const handleChange = (event, new_value) => {
    const next = new_value
      .map((item) => (typeof item === 'string' ? item : String(item)).trim())
      .filter((item) => item);
    onChange(next);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        freeSolo
        options={default_algorithm_options}
        value={algorithms}
        onChange={handleChange}
        disabled={disabled}
        disablePortal
        renderInput={(params) => (
          <TextField
            {...params}
            label='Algorithms'
            required={required}
            error={error}
            placeholder='Type an algorithm and press Enter'
          />
        )}
      />
      <FormHelperText>
        Add signing algorithms as tags (e.g. RS256). Press Enter after each one.
      </FormHelperText>
    </Box>
  );
}
